/* eslint-disable array-callback-return */
import React from "react";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import Tooltip from "../components/Tooltip";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";

import Select from "react-select";

import SearchField from "../components/SearchField";
import InputField from "../components/InputField";
import FilterBar from "../components/FilterBar";
import { SearchIcon } from "@heroicons/react/outline";

// TODO: Refactor to use flatMap function to reduce complexity

// TODO: Create sortTracks function
// const sortTracks = (tracks: any) => {
//   // Remove “All Races“, if exists,
//   // Remove 'R' from all remaining races (if there are any)
//   // Convert to numbers and sort
//   // Append 'R' to the sorted array
//   // Add 'All Races' back if it was taken out
// };

const reduceRaces = (races: any) => {
  const _races: any = [];

  races.forEach((promo: any) => {
    return _races.push(promo.Races);
  });

  //return _.uniq(_races.flat()).sort();
  return _.uniq(_races.flat()).sort((a: any, b: any) => {
    if (a === "All Races") {
      return -1;
    }
    if (Number(a.split("R").pop()) < Number(b.split("R").pop())) {
      return -1;
    }
    if (Number(a.split("R").pop()) > Number(b.split("R").pop())) {
      return 1;
    }
    return 0;
  });
};

export interface Filter {
  id: string;
  name: string;
  component?: string;
  timeValue?: any;
  multiplier?: string;
  condition?: string;
  value?: any;
  options: {
    label: string | number;
    value: string | number;
    checked: boolean;
    isDisabled?: boolean;
  }[];
}

interface IProps {
  selectedCountry: string;
  isDesktopResolution: boolean;
}

export const parseFiltersQuery = (queries: string | string[] | undefined) => {
  // If queries or availableFilters is undefined, return empty array
  if (queries === undefined) return [];

  // If query is a string, convert to array
  if (typeof queries === "string") queries = [queries];

  let filters: Filter[] = [];

  // Parse query string into FilterCondition and add to filters arrays
  queries.forEach((queryString) => {
    const [propertyValue, comparatorValue] = queryString.split(":", 2);

    filters.push({
      id: propertyValue,
      name: propertyValue,
      options: [
        {
          label: comparatorValue,
          value: comparatorValue,
          checked: true,
        },
      ],
    });
  });
  return filters.filter((f) => f.id !== undefined);
};

/**
 * Render react app with redux store
 */
const RacingPromotionsApp: React.FC<IProps> = ({
  selectedCountry,
  isDesktopResolution,
}) => {
  const [data, setData] = React.useState<any>([]);
  const [apiError, setApiError] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(true);

  const [search, setSearch] = React.useState<string>("");

  const [isFilterOpen, setIsFilterOpen] = React.useState<boolean>(false);
  const [query, setQuery] = React.useState<any>("");

  const [selectedDate, setSelectedDate] = React.useState<string>(
    moment(new Date()).format("yyyy-MM-DD")
  );
  const [tracks, setTracks] = React.useState<any>(null);
  const [originalTracks, setOriginalTracks] = React.useState<any>(null);
  const [sortFilter, setSortFilter] = React.useState<any>(null);
  const [isShow, setIsShow] = React.useState<boolean>(false);
  const [sortFilterLoading, setSortFilterLoading] = React.useState<boolean>(
    true
  );

  const [today, setToday] = React.useState<string>(
    moment(new Date()).format("yyyy-MM-DD")
  );
  const [date, setDate] = React.useState<string>(
    moment(new Date()).format("yyyy-MM-DD")
  );

  const [isShowUpgradeModal, setIsShowUpgradeModal] = React.useState<boolean>(
    false
  );

  const urlFilters = parseFiltersQuery(query["filters[]"]);
  const [filters, setFilters] = React.useState<Filter[]>(urlFilters);

  const handleDateSelect = (e: { target: { value: moment.MomentInput } }) => {
    const dayWrapper = moment(e.target.value);
    setSelectedDate(dayWrapper.format("yyyy-MM-DD"));
  };

  const extendedFiltersQuery = (
    filters: Filter[],
    arrayDelimiter?: string
  ): string => {
    let query = "";
    filters.forEach((filter) => {
      const checkedOptions = filter.options.filter((option) => option.checked);

      // Want to skip the filter if there are no checked options
      if (checkedOptions.length === 0) return;

      // Else, the filter should be &filter[filter_id]=option1,option2,option3
      query += `&filter[${filter.id}]=${checkedOptions
        .map((option) => option.value)
        .join(arrayDelimiter || ",")}`;
    });

    return query;
  };

  const Badge = ({ title }: { title: string }) => {
    return (
      <span
        key={title}
        className="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 ring-1 ring-inset ring-gray-200"
      >
        <svg
          className="h-1.5 w-1.5 fill-blue-500"
          viewBox="0 0 6 6"
          aria-hidden="true"
        >
          <circle cx={3} cy={3} r={3} />
        </svg>
        {title}
      </span>
    );
  };

  function stringifyRanges(arr: string[]): string {
    const nums = arr.map((s) => parseInt(s.substring(1))).sort((a, b) => a - b);
    let output = "";
    let start = nums[0];
    let end = nums[0];
    for (let i = 1; i < nums.length; i++) {
      if (nums[i] - nums[i - 1] > 1) {
        if (start === end) {
          output += `R${start}, `;
        } else {
          output += `R${start} - R${end}, `;
        }
        start = nums[i];
        end = nums[i];
      } else {
        end = nums[i];
      }
    }
    if (start === end) {
      output += `R${start}`;
    } else {
      output += `R${start} - R${end}`;
    }
    return output;
  }

  const classNames = (...classes: string[]) => {
    return classes.filter(Boolean).join(" ");
  };

  const PromotionsGroup = ({
    promotions,
    trackName,
    raceType,
  }: {
    promotions: any;
    trackName: string;
    raceType: string;
  }) => {
    const raceOptions = promotions
      .reduce((acc: any, cur: any) => {
        return [...acc, ...cur.races];
      }, [] as string[])
      .filter(
        (value: any, index: any, self: any) => self.indexOf(value) === index
      )
      .sort(
        (a: any, b: any) =>
          Number.parseInt(a.replace("R", "")) -
          Number.parseInt(b.replace("R", ""))
      );

    const [selectedRace, setSelectedRace] = React.useState<string | null>(null);

    return (
      <li className="pt-4">
        <h3 className="text-lg font-medium text-gray-900">
          {trackName}{" "}
          <span>
            {promotions[0].race_type === "greyhound"
              ? "(G)"
              : promotions[0].race_type === "harness"
              ? "(T)"
              : "(H)"}
          </span>
        </h3>

        <ul
          role="list"
          className="mt-1 divide-y divide-gray-200 sm:divide-white"
        >
          {promotions
            // .sort((a, b) => {
            //   // Sum all of the races in the promotion
            //   const aRacesSum = a.races.reduce(
            //     (acc, race) => (acc += Number.parseInt(race.replace("R", ""))),
            //     0
            //   );
            //
            //   const bRacesSum = b.races.reduce(
            //     (acc, race) => (acc += Number.parseInt(race.replace("R", ""))),
            //     0
            //   );
            //
            //   return aRacesSum - bRacesSum;
            // })
            .map((promotion: any) => (
              <li
                key={JSON.stringify(promotion)}
                className="flex flex-wrap items-center justify-between py-5 sm:hidden gap-x-6 gap-y-4 sm:flex-nowrap"
              >
                <div>
                  <p className="text-sm font-semibold leading-6 text-gray-900">
                    <a href={promotion.promotion} className="hover:underline">
                      {promotion.promotion}
                    </a>
                  </p>
                  <div className="flex items-center mt-1 text-xs leading-5 text-gray-500 gap-x-2">
                    <p>{promotion.bookmaker.name}</p>
                    <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                      <circle cx={1} cy={1} r={1} />
                    </svg>
                    <p>{promotion.category}</p>
                    <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                      <circle cx={1} cy={1} r={1} />
                    </svg>
                    <p>{stringifyRanges(promotion.races)}</p>
                  </div>
                </div>
                <dl className="flex justify-between flex-none w-full gap-x-8 sm:w-auto">
                  <div className="flex -space-x-0.5">
                    <dd className="flex items-center justify-center gap-2">
                      <Tooltip content={promotion.bookmaker.name} place="top">
                        <a
                          href={promotion.bookmaker.website_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {promotion.bookmaker.favicon !== "#" && (
                            <img
                              className="w-6 h-6 rounded-full bg-gray-50 ring-2 ring-white"
                              src={promotion.bookmaker.favicon}
                              height={24}
                              width={24}
                              alt={promotion.bookmaker.name}
                            />
                          )}
                        </a>
                      </Tooltip>
                      {promotion.metadata?.map((metadata: any) => (
                        <Badge title={metadata} key={metadata} />
                      ))}
                    </dd>
                  </div>
                </dl>
              </li>
            ))}

          <div className="hidden min-w-full py-2 align-middle sm:inline-block">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    ></th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Races
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Promotion
                    </th>
                    <th scope="col" className="relative px-6 py-3.5">
                      <span className="inline-flex rounded-md isolate">
                        {raceOptions.map((option: any) => (
                          <button
                            key={`${trackName}-${option}`}
                            type="button"
                            onClick={() => {
                              if (selectedRace === option) {
                                setSelectedRace(null);
                              } else {
                                setSelectedRace(option);
                              }
                            }}
                            className={classNames(
                              "relative inline-flex items-center hover:bg-white px-3 py-2 text-sm font-semibold text-gray-900 hover:ring-1 hover:ring-inset hover:ring-gray-300 focus:z-10 rounded-md",
                              selectedRace === option
                                ? "bg-white ring-1 ring-inset ring-gray-300"
                                : "" // Selected
                            )}
                          >
                            {option}
                          </button>
                        ))}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {promotions
                    .filter((promotion: any) =>
                      selectedRace === null
                        ? true
                        : promotion.races.includes(selectedRace)
                    )
                    // .sort((a, b) => {
                    //   // Sum all of the races in the promotion
                    //   const aRacesSum = a.races.reduce(
                    //     (acc, race) =>
                    //       (acc += Number.parseInt(race.replace("R", ""))),
                    //     0
                    //   );
                    //
                    //   const bRacesSum = b.races.reduce(
                    //     (acc, race) =>
                    //       (acc += Number.parseInt(race.replace("R", ""))),
                    //     0
                    //   );
                    //
                    //   return aRacesSum - bRacesSum;
                    // })
                    .map((promotion: any) => (
                      <tr
                        key={`${trackName}-${promotion.bookmaker.name}-${promotion.promotion}`}
                      >
                        <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-6">
                          <div className="w-5 h-5 ml-auto">
                            <Tooltip
                              content={promotion.bookmaker.name}
                              place="top"
                            >
                              <a
                                href={promotion.bookmaker.promotions_url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {promotion.bookmaker.favicon != "#" && (
                                  <img
                                    className="w-5 h-5 rounded-full"
                                    src={promotion.bookmaker.favicon}
                                    height={20}
                                    width={20}
                                    alt={promotion.bookmaker.name}
                                  />
                                )}
                              </a>
                            </Tooltip>
                          </div>
                        </td>
                        <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                          {stringifyRanges(promotion.races)}
                        </td>
                        <td className="relative w-full py-4 pl-3 pr-4 text-sm whitespace-normal">
                          <a
                            href={promotion.bookmaker.promotions_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:underline"
                          >
                            {promotion.promotion}
                          </a>
                        </td>
                        <td className="flex justify-center gap-2 py-6 pr-6">
                          {promotion.metadata?.map((metadata: any) => (
                            <Badge title={metadata} key={metadata} />
                          ))}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </ul>
      </li>
    );
  };

  React.useEffect(() => {
    const fetchFilter = async () => {
      const request_filter = await axios
        .get(
          `https://odds.imperialwealth.com/api/v4/software/promotions/racing/filters?date=${date}${extendedFiltersQuery(
            filters,
            "|"
          )}`
        )
        .then(
          (response: any) => {
            setFilters(response.data);
          },
          (error) => {
            console.log(error);
          }
        );
    };

    fetchFilter();
  }, []);

  React.useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const request_au = await axios
        .get(
          `https://odds.imperialwealth.com/api/v4/software/promotions/racing?filter[date]=${date}&filter[search]=${query}${extendedFiltersQuery(
            filters,
            "|"
          )}`
        )
        .then(
          (response: any) => {
            setData(response.data);
            setLoading(false);
          },
          (error) => {
            console.log(error);
          }
        );
    };

    fetchData();
  }, [selectedDate, query, filters, date]);

  return (
    <React.Fragment>
      <div
        id="app"
        className="racing-promotion flex flex-col overflow-hidden relative z-[9999999999999999999999999]"
        style={{ minHeight: "40rem" }}
      >
        <div className="flex flex-col w-full space-y-3 sm:space-x-3 sm:flex-row sm:space-y-0">
          <div className="flex-grow">
            <SearchField<string>
              placeholder="Search promotions, bookmakers, tracks, etc."
              query={query}
              setQuery={setQuery}
              type="text"
            />
          </div>

          <InputField<string>
            placeholder={today}
            value={date}
            onChange={setDate}
            type="date"
          />
        </div>
        {filters && (
          <FilterBar
            filters={filters}
            setFilters={setFilters}
            setIsShowUpgradeModal={setIsShowUpgradeModal}
          />
        )}

        {/* TODO: */}

        {!loading ? (
          Object.keys(data.data).length > 0 ? (
            <ul role="list" className="divide-y divide-gray-100">
              {Object.keys(data.data)
                .sort()
                .map((trackName) => {
                  const raceTypes = Object.keys(data.data[trackName]);

                  return raceTypes.map((raceType) => {
                    return (
                      <PromotionsGroup
                        key={`${trackName}-${raceType}`}
                        promotions={data.data[trackName][raceType]}
                        trackName={trackName}
                        raceType={raceType}
                      />
                    );
                  });
                })}
            </ul>
          ) : (
            <div className="mt-20 flex gap-4 items-center justify-center w-full">
              <span className="text-xl font-semibold text-gray-900">
                No promotions available for {date} currently.
              </span>
            </div>
          )
        ) : (
          <div className="mt-20 flex gap-4 items-center justify-center w-full">
            <span className="text-xl font-semibold text-gray-900">Loading</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 animate-spin"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default RacingPromotionsApp;
